export const COMPANY_COOKIE = 'company';
